import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './availDatepicker.js';
import Datepicker from '@synergycms_core/components/generic/Datepicker';
import { connect } from 'react-redux';
import RichText from '@synergycms_core/components/generic/RichText';
import { Map, List } from 'immutable';
import actions from '../../../store/actions';
import moment from 'moment';
import Price from '@synergycms_core/components/generic/Price';
import Tabs, { Tab } from '../../generic/TabList';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { parseRestriccions } from '@synergycms_core/components/functional/Engine/engineUtils';
import { formatCurrencyAmount } from '@synergycms_core/utils/utils';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider.jsx';
import { parseAvail } from '@synergycms_app/store/avail/availUtils'
import { iconsByTheme } from '@synergycms_core/components/functional/Engine/engineUtils';

class AvailDatepickerDay extends React.Component {
  static displayName = 'AvailDatepickerDay';

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    // day fields : day, stringDate, isSelected, startRange, endRange, disabled, 
    const { day, data, showTaxes, validCurrency, pricesActive } = config;
    let price = pricesActive && !!day && !!data && (showTaxes ? data.get('price_tax') : data.get('price'));


    const hasRestricccions = !!data && data.get('applied_restrictions') && !!data.get('applied_restrictions').size;
    const disableTooltip = !day || !hasRestricccions;
    return (
      <div className={[theme.computedInnerStyle, classes.dayContainer, (hasRestricccions && !!day) && classes.priceWithRestriction].join(' ')}>
        <TooltipWrapper
          enablePropagation={true}
          autoCloseTimeout={6000}
          family={"EngineDatepickerTooltip"}
          popoverStyle={[theme.computedInnerStyle, classes.tooltipCalendar,!hasRestricccions && classes.displacedCloseButton].join(' ')}
          typeTooltip={!!day && "tooltipDay" + day.format("D")}
          disabled={disableTooltip}
          removeTooltipTimeout={0}
          bottomLimit={100}
          avoidPointer={true}
          popover={(toogleTooltip, forceCloseTooltip) => {
            return (<div className={classes.restrictionContainer}>
              {hasRestricccions &&
                <RichText translate={true} ucFirst={true} withVars={data.get('applied_restrictions').first().toJS()} text={parseRestriccions(data.getIn(['applied_restrictions',0,'type']))} />
              }
            </div>);
          }}
          posX={'middle'}
          posY={'top'}
        >
          <div>
            <RichText text={!!day && day.format("D")} innerStyle={[classes.dayText, (!day && classes.noDispoDayText)]} />
            {price && <Price innerStyle={[classes.priceText, data.bestPrice && classes.bestPrice]} amount={price} hideDecimals={true} hideSymbol={!validCurrency} formatPrice={!validCurrency} tabIndex={0}/>}
          </div>
        </TooltipWrapper>
      </div>
    );
  }
}


const NoAvailDatepickeDay = compose(
  PropertyManager(["day", "stringDate", "isSelected", "startRange", "endRange", "disabled", "data", "showTaxes", "parsePrice", "finalCurrency", "hotelCurrency", "validCurrency", "pricesActive"]),
  withThemeJSS({ styleFile: styleFile, link: true })
)(AvailDatepickerDay)

class AvailDatepicker extends React.Component {
  static displayName = 'AvailDatepicker';

  constructor(props) {
    super(props);
    this.state = {
      startMonth: props.config.start,
      currentFirstMonth: props.config.start, months: props.theme.deviceType === 'MOBIL' ? 4 : 2
    };
    this.cx = props.theme.bind();
  }

  componentDidMount = (next) => {
      this.props.config.newRange(this.state);
  }
  
  
  componentDidUpdate = (next) => {
      this.props.config.newRange(this.state);
  }

  
  

  newRange = (configRange) => {
    const { currentFirstMonth } = configRange;
    this.setState({ startMonth: currentFirstMonth });
    this.props.config.newRange(configRange);
  }

  getTabActiveKey = key => {
    if (this.state.currentBoard !== key) {
      this.setState({
        currentBoard: key
      })
    }
  };
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      finalCurrency,
      hotelCurrency,
      showTaxes,
      validCurrency,
      hotelId,
      start,
      end
    } = config;

    let boardList = (config.boards && config.boards);

    if (config.hideBoards && boardList) {
      let nextBoardOptions;
      const freeBreakFastBoard = config.boards.find((board)=> {
          return board.get('freeBreakFast') && board.get('board_code') !== "14";
        })
        const baseBoard = !freeBreakFastBoard && config.boards.find((board)=> {
            return !board.get("freeBreakFast") && board.get('board_code') === "14";
        })
        const defaultFirstBoard = !freeBreakFastBoard && !baseBoard &&  config.boards.first();
        let finalBoard = freeBreakFastBoard || baseBoard || defaultFirstBoard;
        
        nextBoardOptions = config.boards.filterNot((item) => {
          return [defaultFirstBoard, baseBoard].includes(item);
        });
        
        let parsedRange=Map();
        finalBoard.get("parsedRange", Map()).forEach((data, day)=>{
          let anotherBoardDay;
          let validData = data;
          if(!data.get('price_tax') && (anotherBoardDay = nextBoardOptions.find((board) => !!board.getIn(["parsedRange", day, "price_tax"])))){
            validData = anotherBoardDay.getIn(["parsedRange", day]);
          }
          parsedRange = parsedRange.set(day, validData);
        });
        finalBoard = finalBoard.set("parsedRange", parsedRange);
        boardList = [finalBoard];

    }

    const hasPriceOrTax = boardList.some(board => {
      const parsedRanges = board.get('parsedRange');
      return parsedRanges && parsedRanges.some(dayConfig => {
        return dayConfig.has('price') || dayConfig.has('price_tax');
      });
    });



    let dateStart = start;
    let dateEnd = end;
    const dateIsInvalid = start?.startOf('day').isBefore(moment().startOf('day'));
    
    if(dateIsInvalid) {
      dateStart = false;
      dateEnd = false;
    }

    //hideSingleTab
    return (
      <Tabs titleBlockStyle={'listNoDatepicker'} hideSingleTab={config.hideBoards || boardList.first().get("id", 0) === 0}>
        {boardList.map((board) => {
          return (<Tab
            contentKey={board.get("board_id")+""+hotelId}
            key={board.get("board_id")+""+hotelId}
            innerStyle={[theme.computedInnerStyle, classes.AvailDatepickerCalendar]}
            onTabChange={this.getTabActiveKey}
            tabTitle={{
              richText: {
                innerStyle: ['uppercase'],
                text: board.get("name")
              },
              innerStyle: [classes.tabTitle, 'capitalize']
            }}>
              <>
                <Datepicker
                  monthWrapperClass={config.monthWrapperClass}
                  onRangeChange={(dates) => {
                    if (dates.start && dates.end) {
                      config.closeByFamily("EngineDatepickerTooltip");
                    }
                    config.onRangeChange(dates);
                  }}
                  start={dateStart}
                  end={dateEnd}
                  onScroll={()=>{
                      config.closeByFamily("EngineDatepickerTooltip");
                  }}
                  mobileArrows={config.mobileArrows}
                  firstMonth={dateIsInvalid ? moment() : moment(this.state.startMonth)}
                  months={config.months}
                  innerStyle={['noAvailAlertDatepicker',this.cx({noDispoHeight:config.noDispo})]}
                  minDate={moment()}
                  dayTemplate={
                    board && ((dayConfig) => {
                      return <NoAvailDatepickeDay
                        config={dayConfig}
                        showTaxes={showTaxes}
                        data={board.getIn(["parsedRange", dayConfig.stringDate])}
                        finalCurrency={finalCurrency}
                        hotelCurrency={hotelCurrency}
                        parsePrice={config.parsePrice}
                        validCurrency={validCurrency}
                        pricesActive={config.pricesActive}/>
                        ;
                    })
                  }
                  onChangeCalendar={this.newRange}
                  nextArrow={iconsByTheme('nextArrow',theme.theme)}
                  previousArrow={iconsByTheme('previousArrow',theme.theme)}
                />
                {hasPriceOrTax && config.pricesActive &&
                  <div className={[theme.computedInnerStyle, classes.dateChangeButton].join(' ')}>
                  <div className={classes.aclarationDatepickerTextContainer}>
                    {validCurrency ? <RichText
                      innerStyle={classes.aclarationDatepickerText}
                      ucFirst={true}
                      translate={true}
                      text={'_%* Precios aproximados%_'}
                    /> : 
                    <>
                      <RichText
                        innerStyle={classes.aclarationDatepickerText}
                        ucFirst={true}
                        translate={true}
                        withVars={{currency: finalCurrency.get("code")}}
                        text={'_%* Precios aproximados en {currency}%_'}/>
                      {' '}
                    </>
                    }
                  </div>
                </div>
                }
              </>
          </Tab>);
        })}
      </Tabs>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    newRange: ({ currentFirstMonth, months }) => {
      
      const current = moment();
      const start = current > currentFirstMonth ? current : moment(currentFirstMonth).startOf("month");
      const end = moment(start).add(months - 1, "month").endOf("month");
      
      const selected = ownProps.selectedSearch;
      const hotels = selected && selected.id && selected.code ? selected.id : null;

      dispatch(actions.availCalendar.getAsync(start, end, Map({hotels}), !ownProps.roomId));
    },

  };
};




const mapStateToProps = (store, ownProps) => {
  let data = null;

  const selected = ownProps.selectedSearch;
  const alterHotelId = selected && selected.id && selected.code ? selected.id : null;
  const currentHotel = store.getIn(["customer", "current_hotel"]);
  const hotelState = store.getIn(['hotels', currentHotel], Map());

  const shownHotelCountry = alterHotelId ? selected.country_iso_code : hotelState.get('country_iso_code');
  const excludePricesForShownHotel = shownHotelCountry === 'US' && store.get('group') === 'eurostarshotels';

  let stringParams = store.getIn(['hotels', currentHotel, 'params', store.getIn(["availQuery", "mono", `${!ownProps.roomId ?"base_" : ""}calendar_query_params`])]);
  
  const currentCurrencyCode = store.getIn(['customer', 'current_currency']) || undefined;
  const currencies = store.getIn(['customer', 'currencies'], List());
  const queryParams = store.getIn(['customer', 'params', 'url_params']);

  const validCurrency = (["EUR", "USD", "GBP"]).includes(currentCurrencyCode);
  const pricesActive = alterHotelId  ? !excludePricesForShownHotel: store.getIn(['app', 'config', 'prices_active'], true);    
  const shownHotelSummaryPriceBreakdown = alterHotelId ? false : hotelState.get('summary_price_breakdown', false);
  
  data = store.getIn(['availCalendar', alterHotelId || currentHotel, stringParams, "response"]);

  if(ownProps.roomId && data) {
    const hotelAvailData = store.getIn(['availCalendar', alterHotelId || currentHotel, stringParams], Map());
    
    data = (hotelAvailData.get("raw_response") && parseAvail(
      hotelAvailData.get("raw_response"),
      hotelAvailData.get('minPrice'),
      hotelAvailData.get('maxPrice'),
      hotelAvailData.get('freeBreakFast'),
      hotelState.get("show_taxes", true),
      ownProps.roomId
    ));
  }

  let boardList;

  if (data?.getIn(["boardList"])) {
    //data = data.getIn(["boardList", 0, "baseRange"], List());
    boardList = data.getIn(["boardList"]).reduce((boards, board) => {
      return boards.push(board.set("parsedRange", board.get("baseRange").reduce((acc, val) => {
        return acc.set(val.get("checkin"), val);
      }, Map())));
    }, List());
  }
  const hotelCurrency = ownProps.hotelCurrencyCode ||
  store.getIn(['hotels', store.getIn(['customer', 'current_hotel']), 'currency', 'code']) || // Monohotel
  (store.get('hotels').find((v, k) => Number.isFinite(+k)) || Map()).getIn(['currency', 'code']); // Multihotel

  //si no recibe props usar moment(queryParams)
  //si recibe props y no son null moment(props), puede ser null al no seleccionar fecha en busqueda
  let start, end 
  if(ownProps.start === undefined){
    start = moment(queryParams?.get("start"));
  }else{
    start = (ownProps.start !== null) ? moment(ownProps.start) : null
  }
  if(ownProps.end === undefined){
    end = moment(queryParams?.get("end"));
  }else{
    end = (ownProps.end !== null) ? moment(ownProps.end)  : null
  }


  return {
    start,
    end,
    showTaxes: hotelState.get('show_taxes'),
    boards: boardList || List([Map({ baseRange: List(), board_id: 0, name: 'Calendar' })]),
    finalCurrency: currencies.find(c => c.get('code') === currentCurrencyCode),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: currentCurrencyCode,
    parsePrice: formatCurrencyAmount(currencies, currentCurrencyCode, store.getIn(['customer', 'lang_info'])),
    hotelCurrency: currencies.find(c => c.get('code') === hotelCurrency),
    validCurrency: validCurrency,
    hotelId :currentHotel,
    pricesActive: pricesActive && !shownHotelSummaryPriceBreakdown
  };
};

//onRangeChange={this.updateRange}
//start={start}
//end={end}
//months={2}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  showPopover,
  PropertyManager(['hotelId','occups', 'onRangeChange', 'start', 'end', 'months', 'mobileArrows', 'boards', 'onChangeCalendar', 'roomId', 'showTaxes', 'datepickerStyle', 'parsePrice',"hotelCurrency", 'finalCurrency', 'newRange', 'hideBoards', 'closeByFamily', 'validCurrency', 'monthWrapperClass','noDispo', 'pricesActive']),
  withThemeJSS({ styleFile, link: true })
)(AvailDatepicker);
